import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';

export const WorkspaceFileDelete = createAction(
  '[WorkspaceFile] Delete',
  props<{ workspaceId: string; fileId: string }>()
);
export const WorkspaceFileDeleted = createAction('[WorkspaceFile] Deleted', props<{ fileId: string }>());
export const WorkspaceFileError = createAction('[WorkspaceFile] Delete Error', props<{ fileId: string }>());

export const initialState: Record<string, CommonApiState<undefined>> = {};

export const workspaceFileFeature = createFeature({
  name: 'workspaceFile',
  reducer: createReducer(
    initialState,
    on(WorkspaceFileDelete, (state, action) => ({
      ...state,
      [action.fileId]: {
        ...(state[action.fileId] ?? {}),
        currentPedingApis: (state[action.fileId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(WorkspaceFileDeleted, (state, action) => {
      return {
        ...state,
        [action.fileId]: {
          ...(state[action.fileId] ?? {}),
          currentPedingApis: 0,
          isError: false
        }
      };
    }),
    on(WorkspaceFileError, (state, action) => {
      return {
        ...state,
        [action.fileId]: {
          ...(state[action.fileId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectWorkspaceFileState }) => {
    const workspaceFileIsBeingDeleted = (fileId: string) =>
      createSelector(
        selectWorkspaceFileState,
        workspaceFileState => (workspaceFileState[fileId]?.currentPedingApis ?? 0) > 0
      );
    const workspaceFilesAreBeingDeleted = createSelector(selectWorkspaceFileState, workspaceFileState =>
      Object.entries(workspaceFileState).reduce((curr, [fileId, value]) => {
        return { ...curr, [fileId]: value.currentPedingApis > 0 };
      }, {})
    );

    const workspaceFileHasPendingRequest = (fileId: string) =>
      createSelector(
        selectWorkspaceFileState,
        workspaceFileState => (workspaceFileState[fileId]?.currentPedingApis ?? 0) >= 2
      );

    return {
      workspaceFileIsBeingDeleted,
      workspaceFileHasPendingRequest,
      workspaceFilesAreBeingDeleted
    };
  }
});
